<template>
    <section class="login-section">
        <div class="thumb-container absolute" :style='"background-image: url(" + color + ")"'></div>
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 col-lg-8 col-xl-5">
                    <div class="has-header d-flex">
                        <div class="form-content form-team-content w-100 white-content d-flex align-items-center flex-column bd-highlight mb-3">
                            <h3>{{ $t('ayuda.gracias') }}</h3>
                            <h4>{{ $t('ayuda.responder') }}</h4>
                            <h5 class="ml-5 mr-5 mt-2 text-center">{{$t('ayuda.pregunta_info')}}</h5>
                            <button class="button mt-3"> 
                                <router-link :to="{ name: 'front.faqs.index' }">
                                    <span class="text-white">FAQ</span>
                                </router-link>
                            </button>
                            <h5 class="mt-4">{{ $t('ayuda.rapido') }}</h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>


<script>
    export default {
        props: ['color'],
    }
</script>